<template>
  <div class="container">
    <div name="gameHeader">
      <div class="row">
        <div name="gameTitle" class="col-lg-8 col-md-7">
          <h3>Game: {{ gameName }}</h3>
        </div>
        <div name="gameOperations" class="col-lg-4 col-md-5">
          <div v-if="userIsInGroup('redeemers')">
            <span class="float-md-right">
              <a type="button" class="btn btn-primary btn-sm text-right" @click="confirmRedeem()">Redeem</a>
              <div style="width:8px;height:auto;display:inline-block;" />
              <a type="button" class="btn btn-secondary btn-sm text-right" @click="editGame()">Edit</a>
              <div style="width:8px;height:auto;display:inline-block;" />
              <a type="button" class="btn btn-secondary btn-sm text-right" @click="fixMatch()">Fix Match</a>
              <div style="width:8px;height:auto;display:inline-block;" />
              <a type="button" class="btn btn-danger btn-sm text-right" v-if="userIsInGroup('admins')" @click="deleteKey()">Delete</a>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div name="pageContent" class="row">
      <div name="mainContent" class="col-md-8 col-sm-9">
        <div name="gameInfo">
          <div name="loadingMsg" v-if="$apollo.loading">
            <h3>Loading game information, please wait...</h3>
          </div>
          <div v-if="!$apollo.loading && gameInfo">
            <div name="gameInfo">
              <table class="table table-sm table-hover table-striped">
                <tr>
                  <th>Name:</th>
                  <td>{{ gameInfo.name }}</td>
                </tr>
                <tr>
                  <th>Notes:</th>
                  <td>{{ gameInfo.notes }}</td>
                </tr>
                <tr>
                  <th>Submitted:</th>
                  <td>By {{ gameInfo.submitter }} {{ gameInfo.submitTime | moment("from", "now") }}</td>
                </tr>
                <tr v-if="gameInfo.updater">
                  <th>Updated:</th>
                  <td>By {{ gameInfo.updater }} {{ gameInfo.updateTime | moment("from", "now") }}</td>
                </tr>
                <tr>
                  <th>Status:</th>
                  <td v-if="gameInfo.redeemed">
                    <span style="color: red;">
                      <font-awesome-icon icon="exclamation-circle" fixed-width />
                      Redeemed: {{ gameInfo.redeemer }} {{ gameInfo.redeemTime | moment("from", "now") }}
                    </span>
                  </td>
                  <td v-if="!gameInfo.redeemed">
                    <span style="color: green;">
                      <font-awesome-icon icon="check-circle" fixed-width />
                      Available
                    </span>
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <div name="dlcTable" v-if="gameInfo.dlcs">
            <h4>DLC:</h4>
            <table class="table table-sm table-hover table-striped">
              <tr>
                <th>DLC Name</th>
                <th>Notes</th>
              </tr>
              <tr v-for="(dlc, index) in gameInfo.dlcs" :key="index">
                <td>{{ dlc.name }}</td>
                <td>{{ dlc.notes }}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div name="sidebar" class="col-md-4 col-sm-3">
        <div v-if="rawgInfo">
          <h3>{{ rawgInfo.name }}</h3>
          <img v-if="rawgInfo.background_image" :src="rawgInfo.background_image" />
        </div>
      </div>
    </div>
    <div class="row">
      <div name="rawgInfoMainColumn" v-if="rawgInfo" class="col-md-8 col-sm-9">
        <div id="screenshotCarousel" v-if="rawgScreenshots" class="carousel slide" data-ride="carousel">
          <ol class="carousel-indicators">
            <li
              v-for="(ss, index) in rawgScreenshots.results"
              v-bind:key="index"
              data-target="#screenshotCarousel"
              :data-slide-to="index"
              :class="(index == 0)?'active':''"
            ></li>
          </ol>
          <div class="carousel-inner">
            <div
              v-for="(ss, index) in rawgScreenshots.results"
              v-bind:key="index"
              :class="(index == 0)?'carousel-item active':'carousel-item'"
            >
              <img style="max-width: 100%; height: auto;" :src="ss.image" :alt="'Screenshot: '+index">
            </div>
          </div>
          <a class="carousel-control-prev" href="#screenshotCarousel" role="button" data-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
          </a>
          <a class="carousel-control-next" href="#screenshotCarousel" role="button" data-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
          </a>
        </div>
        <!--
        <div v-if="rawgInfo.clip">
          <video width="320" height="240" controls>
            <source :src="rawgInfo.clip.clips.full" type="video/mp4">
            Your browser does not support the video tag.
          </video>
        </div>
        -->
        <h3 v-if="rawgInfo.description">Description:</h3>
        <div v-if="rawgInfo.description" v-html="rawgInfo.description" />
      </div>
      <div name="rawgInfoSideColumn" v-if="rawgInfo" class="col-md-4 col-sm-3">
        <div v-if="rawgStoreInfo">
          <b>Store(s):</b>
          <ul>
            <li v-for="(store,index) in rawgStoreInfo" v-bind:key="index">
              <a :href="store.url" target="_blank">{{ rawgInfo.stores[index].store.name }}</a>
            </li>
          </ul>
        </div>
        <div v-if="rawgInfo.rating && rawgInfo.rating_top">
          <b>RAWG Rating</b>
          <ul>
            <li>
              <a :href="'https://rawg.io/games/'+rawgInfo.slug" target="_blank">
                RAWG: 
              </a>{{ rawgInfo.rating }}/{{ rawgInfo.rating_top }}
            </li>
          </ul>
        </div>
        <div v-if="rawgInfo.metacritic_url">
          <b>Metacritic Score(s):</b>
          <ul>
            <li v-for="(metaPage, index) in rawgInfo.metacritic_platforms" v-bind:key="index">
              <a
                :href="metaPage.url"
                target="_blank"
              >{{ metaPage.platform.name }}: </a>{{ metaPage.metascore }}
            </li>
          </ul>
        </div>
        <div v-if="rawgInfo.genres && rawgInfo.genres.length > 0">
          <b>Genres:</b>
          <ul>
            <li v-for="(genre,index) in rawgInfo.genres" v-bind:key="index">{{ genre.name }}</li>
          </ul>
        </div>
        <div v-if="rawgInfo.tags">
          <b>Tags:</b>
          <ul>
            <li v-for="(tag,index) in rawgInfo.tags" v-bind:key="index">{{ tag.name }}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import axios from 'axios'

export default {
  name: 'Game',
  props: ['user'],
  data() {
    return {
      gameName: this.$route.params.gameId,
      gameInfo: {},
      rawgInfo: {},
      rawgScreenshots: {},
      rawgStoreInfo: {}
    }
  },
  methods: {
    userIsInGroup(group) {
      // The token payload holds an array of groups the user is in and indexOf will return the
      // index of the group name if it is found but -1 if it is not
      try {
        return this.user.signInUserSession.accessToken.payload['cognito:groups'].indexOf(group) > -1
      } catch {
        // User wasn't logged in so token didn't exist
        return false
      }
    },
    editGame() {
      this.$router.push('/editgame/'+this.$route.params.gameId)
    },
    deleteKey() {
      if (confirm("Are you sure you want to delete this key?")) {
        var input = { KeyId: this.gameInfo.KeyId }
        // Execute delete mutation
        this.$apollo.mutate({
          mutation: gql`mutation ($KeyId: ID!) {
            deleteKey(KeyId: $KeyId) {
              KeyId
            }
          }`,
          variables: input
        }).then(() => {
          // Redirect to home page
          this.$router.push('/')
        }).catch((error) => {
          // Show error message
          alert('Error deleting key: ' + error)
        })
      }
    },
    confirmRedeem() {
      if (confirm('Are you sure you want to redeem this key?')) {
        // Redirect to redeem page
        this.$router.push('/redeem/'+this.$route.params.gameId)
      }
    },
    fixMatch() {
      this.$router.push('/match/'+this.$route.params.gameId)
    },
    getRawgInfo() {
      axios.get(encodeURI('https://api.rawg.io/api/games/'+this.gameInfo.rawgId+'?key=9b3d6882da4d45c3b7252e508a223a6b'))
      .then( response => {
        this.rawgInfo = response.data
        if (response.data.screenshots_count && response.data.screenshots_count > 0){
          this.getRawgScreenshots()
          this.getRawgStoreInfo()
        } else {
          this.loading = false
        }
      })
      .catch( error => {
        this.errorMessage = error
        this.loading = false
      })
    },
    getRawgScreenshots() {
      this.loading = true

      axios.get(encodeURI('https://api.rawg.io/api/games/'+this.gameInfo.rawgId+'/screenshots?key=9b3d6882da4d45c3b7252e508a223a6b'))
      .then( response => {
        this.rawgScreenshots = response.data
        this.loading = false
      })
      .catch( error => {
        this.errorMessage = error
        this.loading = false
      })
    },
    getRawgStoreInfo() {
      this.loading = true

      axios.get(encodeURI('https://api.rawg.io/api/games/'+this.gameInfo.rawgId+'/stores?key=9b3d6882da4d45c3b7252e508a223a6b'))
      .then( response => {
        this.rawgStoreInfo = response.data.results
        this.loading = false
      })
      .catch( error => {
        this.errorMessage = error
        this.loading = false
      })
    }
  },
  apollo: {
    gameInfo: {
      query () {
        if (this.userIsInGroup('redeemers')) {
          return gql`query getKey ($KeyId: ID!) {
            gameInfo: getKey(KeyId: $KeyId) {
              KeyId
              name
              key
              notes
              rawgId
              submitter
              submitTime
              redeemer
              redeemed
              redeemTime
              updater
              updateTime
              dlcs {
                name
                key
                notes
              }
            }
          }`
        } else {
          return gql`query getKey ($KeyId: ID!) {
            gameInfo: getKey(KeyId: $KeyId) {
              KeyId
              name
              notes
              rawgId
              submitter
              submitTime
              redeemed
              redeemTime
              dlcs {
                name
                notes
              }
            }
          }`
        }
      },
      variables () {
        return { KeyId: this.$route.params.gameId }
      },
      result () {
        this.gameName = this.gameInfo.name
        if (this.gameInfo.rawgId) {
          this.getRawgInfo()
        }
      }
    }
  }
}
</script>